module.exports = __webpack_public_path__ + "img/SmilingFace.d2c1538c.svg";